export default function Error(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={239}
      height={209}
      fill="none"
      {...props}>
      <g clipPath="url(#a)">
        <path
          fill="#F3123C"
          d="M49.18 74.17c0 .59-.18 1.17-.5 1.66a2.994 2.994 0 0 1-3.07 1.27c-.58-.12-1.11-.4-1.53-.82-.42-.42-.7-.95-.82-1.53-.12-.58-.06-1.18.17-1.73s.61-1.01 1.1-1.34c.49-.33 1.07-.5 1.66-.5.79 0 1.55.32 2.11.88.56.56.88 1.32.88 2.11Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M49.25 180.23h-6.62c-1.06 0-2.11-.21-3.09-.61-.98-.41-1.88-1-2.63-1.75a8.138 8.138 0 0 1-1.75-2.62c-.4-.98-.61-2.03-.61-3.1V69.03c0-1.06.21-2.11.61-3.09.41-.98 1-1.87 1.75-2.62s1.65-1.35 2.63-1.75c.98-.41 2.03-.62 3.09-.62h56.95l53.98.02h47.5c1.06 0 2.12.21 3.09.62.98.4 1.88 1 2.63 1.75a8.11 8.11 0 0 1 1.74 2.62c.41.98.62 2.03.62 3.1v103.09c0 1.07-.21 2.12-.62 3.1-.4.98-1 1.87-1.75 2.62s-1.64 1.34-2.62 1.75c-.98.4-2.03.61-3.09.61H49.25ZM34.55 85.71h174.59"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M49.18 74.17c0 .59-.18 1.17-.5 1.66a2.994 2.994 0 0 1-3.07 1.27c-.58-.12-1.11-.4-1.53-.82-.42-.42-.7-.95-.82-1.53-.12-.58-.06-1.18.17-1.73s.61-1.01 1.1-1.34c.49-.33 1.07-.5 1.66-.5.79 0 1.55.32 2.11.88.56.56.88 1.32.88 2.11v0ZM58.21 74.17c0 .59-.18 1.17-.5 1.66a2.994 2.994 0 0 1-3.07 1.27c-.58-.12-1.11-.4-1.53-.82-.42-.42-.7-.95-.82-1.53-.11-.58-.05-1.18.17-1.73a2.97 2.97 0 0 1 2.76-1.84c.79 0 1.55.32 2.11.88.56.56.87 1.32.88 2.11v0ZM67.26 74.17c0 .59-.18 1.17-.5 1.66a2.994 2.994 0 0 1-3.07 1.27c-.58-.12-1.11-.4-1.53-.82-.42-.42-.7-.95-.82-1.53-.12-.58-.06-1.18.17-1.73s.61-1.01 1.1-1.34c.49-.33 1.07-.5 1.66-.5.79 0 1.55.32 2.11.88.56.56.88 1.32.88 2.11v0Z"
        />
        <path
          fill="#F3123C"
          d="M130.26 34.65c0 .73-.22 1.45-.62 2.06-.41.61-.99 1.08-1.66 1.36-.68.28-1.42.35-2.14.21-.72-.14-1.38-.5-1.9-1.01-.52-.52-.87-1.18-1.01-1.9s-.07-1.46.21-2.14c.28-.68.76-1.26 1.36-1.66.61-.41 1.33-.62 2.06-.62.98 0 1.92.39 2.62 1.09.69.69 1.09 1.64 1.09 2.62l-.01-.01ZM135.56 104.73h-17.98v16.18h17.98v-16.18ZM100.05 147.65c0 .51-.15 1.01-.44 1.44-.29.43-.69.76-1.16.95-.47.2-.99.25-1.5.15-.5-.1-.96-.35-1.32-.71a2.577 2.577 0 0 1-.56-2.82c.2-.47.53-.88.95-1.16.43-.29.93-.44 1.44-.44.69 0 1.34.27 1.83.76s.76 1.14.76 1.83ZM158.76 169.09c0 .51-.15 1.01-.44 1.44-.29.43-.69.76-1.16.95-.47.2-.99.25-1.5.15-.5-.1-.96-.35-1.32-.71a2.577 2.577 0 0 1-.56-2.82c.2-.47.53-.88.95-1.16.43-.29.93-.44 1.44-.44.69 0 1.34.28 1.83.76s.76 1.14.76 1.83Z"
        />
        <path
          fill="#737373"
          d="M115.09 66.87c0 .55-.17 1.09-.47 1.55-.31.45-.74.81-1.25 1.02-.51.21-1.07.26-1.61.16a2.9 2.9 0 0 1-1.42-.76c-.38-.39-.65-.89-.76-1.43-.1-.54-.05-1.09.16-1.6.21-.51.57-.94 1.02-1.25.46-.3 1-.47 1.55-.47.74 0 1.44.3 1.96.82s.82 1.23.82 1.96ZM143.59 66.87a2.77 2.77 0 0 1-1.72 2.57c-.5.21-1.06.27-1.6.16-.54-.11-1.04-.37-1.43-.76-.38-.39-.65-.88-.76-1.42-.1-.54-.05-1.1.16-1.61.21-.51.57-.94 1.02-1.25.46-.3 1-.46 1.55-.46a2.779 2.779 0 0 1 2.78 2.77Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M82.67 180.23h-7.08"
        />
        <path
          fill="#F5F5F5"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M151.98 52.33a5.39 5.39 0 0 0-3.81-1.58h-43.2c-1.43 0-2.8.57-3.81 1.58a5.39 5.39 0 0 0-1.58 3.81v43.2c0 1.43.57 2.8 1.58 3.81a5.39 5.39 0 0 0 3.81 1.58h43.2c1.43 0 2.8-.57 3.81-1.58a5.39 5.39 0 0 0 1.58-3.81v-43.2c0-1.43-.57-2.8-1.58-3.81Zm-37.36 16.09c-.31.45-.74.81-1.25 1.02-.51.21-1.07.26-1.61.16a2.9 2.9 0 0 1-1.42-.76c-.38-.39-.65-.89-.76-1.43-.1-.54-.05-1.09.16-1.6.21-.51.57-.94 1.02-1.25.46-.3 1-.47 1.55-.47.74 0 1.44.3 1.96.82s.82 1.23.82 1.96c0 .55-.17 1.09-.47 1.55Zm28.5 0c-.31.46-.74.81-1.25 1.02-.5.21-1.06.27-1.6.16-.54-.11-1.04-.37-1.43-.76-.38-.39-.65-.88-.76-1.42-.1-.54-.05-1.1.16-1.61.21-.51.57-.94 1.02-1.25.46-.3 1-.46 1.55-.46a2.779 2.779 0 0 1 2.31 4.32Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M114.27 64.91c.52.52.82 1.23.82 1.96 0 .55-.17 1.09-.47 1.55-.31.45-.74.81-1.25 1.02-.51.21-1.07.26-1.61.16a2.9 2.9 0 0 1-1.42-.76c-.38-.39-.65-.89-.76-1.43-.1-.54-.05-1.09.16-1.6.21-.51.57-.94 1.02-1.25.46-.3 1-.47 1.55-.47.74 0 1.44.3 1.96.82v0ZM143.59 66.87a2.77 2.77 0 0 1-1.72 2.57c-.5.21-1.06.27-1.6.16-.54-.11-1.04-.37-1.43-.76-.38-.39-.65-.88-.76-1.42-.1-.54-.05-1.1.16-1.61.21-.51.57-.94 1.02-1.25.46-.3 1-.46 1.55-.46a2.779 2.779 0 0 1 2.78 2.77v0Z"
        />
        <path
          fill="#F5F5F5"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M170.46 128.86v51.37H82.67v-51.37c0-2.11.84-4.13 2.33-5.63a7.948 7.948 0 0 1 5.62-2.33h71.87c2.11 0 4.14.84 5.63 2.33a7.938 7.938 0 0 1 2.34 5.63Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M146.32 180.24v-33.16c0-.95-.38-1.86-1.05-2.53a3.58 3.58 0 0 0-2.53-1.05h-32.35c-.95 0-1.86.38-2.53 1.05a3.58 3.58 0 0 0-1.05 2.53v33.16M117.58 120.91v-16.17M135.56 104.73v16.17"
        />
        <path
          fill="#F5F5F5"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M75.59 97.92v82.31H49.25V99.79c0-.7.28-1.37.77-1.86s1.17-.77 1.87-.77c.7 0 1.37.27 1.86.77.5.49.78 1.16.78 1.86h.02v10.55h15.77V97.92c0-.7.28-1.37.77-1.87.5-.49 1.17-.77 1.86-.77.69 0 1.37.28 1.87.77.49.5.77 1.17.77 1.87Z"
        />
        <path
          fill="#F5F5F5"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M68.57 92.62v17.72h-5.28v-17.7c0-3.44 5.28-3.58 5.28-.02Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="m75.73 122.74 9.48-8.76c.25-.24.46-.52.61-.83.14-.31.23-.65.24-1 .01-.35-.04-.69-.16-1.02-.12-.33-.3-.62-.54-.88-.24-.25-.52-.46-.83-.61a2.667 2.667 0 0 0-2.02-.08c-.33.12-.62.3-.88.54l-6.03 5.56"
        />
        <path
          fill="#F5F5F5"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M61.56 96.11v14.23h-5.3V96.11c.01-.69.3-1.35.79-1.83a2.642 2.642 0 0 1 3.71 0c.49.48.78 1.14.8 1.83Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M49.25 106.11h5.3M56.26 99.25h5.3M56.26 106.11h5.3M63.34 106.11h5.24M63.34 99.25h5.23M70.32 99.25h5.27M70.32 106.11h5.27M72.24 110.34h-1.92M54.55 110.34h-2.26M78.25 113.21l3.61 3.87M49.25 130.15h26.34M49.25 139.15h26.34M49.25 148.15h26.34M49.25 157.15h26.34M49.25 166.15h26.34M49.25 175.15h26.34M126.56 50.75V38.33M130.26 34.65c0 .73-.22 1.45-.62 2.06-.41.61-.99 1.08-1.66 1.36-.68.28-1.42.35-2.14.21-.72-.14-1.38-.5-1.9-1.01-.52-.52-.87-1.18-1.01-1.9s-.07-1.46.21-2.14c.28-.68.76-1.26 1.36-1.66.61-.41 1.33-.62 2.06-.62.98 0 1.92.39 2.62 1.09.7.69 1.09 1.64 1.09 2.62l-.01-.01ZM115.09 66.87c0 .55-.17 1.09-.47 1.55-.31.45-.74.81-1.25 1.02-.51.21-1.07.26-1.61.16a2.9 2.9 0 0 1-1.42-.76c-.38-.39-.65-.89-.76-1.43-.1-.54-.05-1.09.16-1.6.21-.51.57-.94 1.02-1.25.46-.3 1-.47 1.55-.47.74 0 1.44.3 1.96.82s.82 1.23.82 1.96v0ZM143.59 66.87a2.77 2.77 0 0 1-1.72 2.57c-.5.21-1.06.27-1.6.16-.54-.11-1.04-.37-1.43-.76-.38-.39-.65-.88-.76-1.42-.1-.54-.05-1.1.16-1.61.21-.51.57-.94 1.02-1.25.46-.3 1-.46 1.55-.46a2.779 2.779 0 0 1 2.78 2.77v0ZM131.88 73.49c-3.63-2.35-7.2-2.5-10.64 0M117.58 109.94h17.98M117.58 115.73h17.98M97.47 180.24v-30"
        />
        <path
          fill="#F3123C"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M100.05 147.65c0 .51-.15 1.01-.44 1.44-.29.43-.69.76-1.16.95-.47.19-.99.25-1.5.15-.5-.1-.96-.35-1.32-.71a2.577 2.577 0 0 1-.56-2.82c.2-.47.53-.88.95-1.16.43-.28.93-.44 1.44-.44.69 0 1.34.27 1.83.76s.76 1.14.76 1.83Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M156.15 180.24v-8.55"
        />
        <path
          fill="#F3123C"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M158.76 169.09c0 .51-.15 1.01-.44 1.44-.29.43-.69.76-1.16.95-.47.2-.99.25-1.5.15-.5-.1-.96-.35-1.32-.71a2.577 2.577 0 0 1-.56-2.82c.2-.47.53-.88.95-1.16.43-.29.93-.44 1.44-.44.69 0 1.34.28 1.83.76s.76 1.14.76 1.83Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M156.15 166.48v-28.33a4.164 4.164 0 0 0-4.16-4.16h-50.37a4.164 4.164 0 0 0-4.16 4.16v6.89M119.51 34.65h-5.49M121.57 39.61l-3.87 3.9M126.56 27.52v-5.98M121.55 29.61l-4.25-4.25M133.61 34.65h5.49M131.55 39.61l3.89 3.9M131.59 29.61l4.25-4.25"
        />
        <path
          fill="#F3123C"
          fillRule="evenodd"
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M131.05 160.98c-.03-.68-.22-1.36-.58-1.97l-3.13-5.4c-.24-.41-.4-.85-.5-1.31l-.13.23a4.328 4.328 0 0 0 0 4.32l2.51 4.32c.77 1.34.77 2.98 0 4.32l-.13.22a4.46 4.46 0 0 0-.49-1.3l-3.76-6.48c-.24-.41-.4-.85-.49-1.3l-.13.22a4.31 4.31 0 0 0 0 4.31l2.51 4.33c.77 1.34.77 2.98 0 4.32l-.13.23c-.09-.45-.26-.89-.5-1.31l-3.13-5.4c-.42-.72-.61-1.54-.58-2.35-3.35.87-5.67 2.72-5.67 4.87 0 2.98 4.48 5.4 10 5.4s10-2.42 10-5.4c0-2.14-2.31-4-5.67-4.87Z"
          clipRule="evenodd"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M96.25 204.94c0 .67-.2 1.33-.57 1.89a3.38 3.38 0 0 1-3.48 1.44c-.66-.13-1.26-.46-1.74-.93-.47-.48-.8-1.08-.93-1.74-.13-.66-.06-1.34.19-1.96.26-.62.69-1.15 1.25-1.52.56-.37 1.22-.57 1.89-.57a3.39 3.39 0 0 1 2.4 1 3.386 3.386 0 0 1 1 2.4l-.01-.01ZM190.54 104.52a2.615 2.615 0 0 1-3.12 2.56c-.51-.1-.97-.35-1.34-.71-.36-.37-.61-.83-.71-1.34-.1-.51-.05-1.03.15-1.51s.53-.89.96-1.17c.43-.29.93-.44 1.45-.44.69 0 1.35.28 1.84.77s.77 1.15.77 1.84v0ZM9.17 69.04v17.41M17.88 77.74H.47M232.51 116.56l-6.7 14.9h12.16l-6.7 14.9M182.46 30.36c-.51 0-1.01-.2-1.37-.57-.36-.36-.57-.86-.57-1.37V2.41c0-.51.21-1.01.57-1.37.36-.36.86-.57 1.37-.57.51 0 1.01.2 1.37.57.36.36.57.86.57 1.37v26.02c0 .51-.21 1-.57 1.36-.36.36-.86.57-1.37.57Z"
        />
        <path
          fill="#737373"
          fillRule="evenodd"
          d="M182.46 30.36c-.51 0-1.01-.2-1.37-.57-.36-.36-.57-.86-.57-1.37V12.7c-9.32.93-16.59 8.15-16.59 16.9 0 3.29 1.05 6.5 2.97 9.17l-2.97 7.84 7.8-3.18c3.22 2.09 6.98 3.19 10.82 3.18 10.28 0 18.62-7.63 18.62-17 0-8.84-7.36-16.08-16.78-16.92v15.73c0 .51-.21 1-.57 1.36-.36.36-.86.57-1.37.57l.01.01Zm2.24 6.55c0 1.24-1 2.24-2.24 2.24-1.24 0-2.24-1-2.24-2.24 0-1.24 1-2.24 2.24-2.24 1.24 0 2.24 1 2.24 2.24Z"
          clipRule="evenodd"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M182.46 39.15c1.24 0 2.24-1 2.24-2.24 0-1.24-1-2.24-2.24-2.24-1.24 0-2.24 1-2.24 2.24 0 1.24 1 2.24 2.24 2.24Z"
        />
        <path
          stroke="#595959"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.94}
          d="M182.56 12.61c-10.28 0-18.62 7.62-18.62 17 0 3.29 1.05 6.5 2.97 9.17l-2.97 7.84 7.8-3.18c3.22 2.09 6.98 3.19 10.82 3.18 10.28 0 18.62-7.62 18.62-17 0-9.38-8.34-17-18.62-17v-.01Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h238.44v208.8H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
